<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
        outline: none;
        -webkit-tap-highlight-color: rgba(255, 0, 0, 0);
        vertical-align: baseline;
         font-style: normal;
        }

        body {
            margin:0;
            padding:0;
            font-size: 14px;
            font-family: Microsoft Yahei, Arial, Simsun, Helvetica, Segoe UI, sans-serif;
            color: #404040;
        }

        img {
            border: 0
        }

        ul, ol, li, dt, dl, dd {
            text-decoration: none;
            list-style: none;
            vertical-align: middle;
            margin: 0;
            padding: 0;
        }

        a {
            color: #777;
            text-decoration: none;
        }
        input::-webkit-inner-spin-button{
            -webkit-appearance: none !important;
            margin: 0;
            -moz-appearance: textfield;
        }
        ::-webkit-scrollbar {
        	width: 6px;
        	height: 6px;
        	background: #ddd;   /*可以设置轨道颜色*/
        	padding-right: 2px;
        }

        /*滚动条*/
        ::-webkit-scrollbar-thumb {
        	background: #999;
        	border-radius: 6px;
        }
        .title {height:40px;line-height:30px;}
        .title b {color:#555;font-size:16px;margin-left:10px;}
        .nodata {color:#777;height:350px;text-align: center;}
        .nodata img {margin-top:150px;}
        .addMember .el-cascader {width:270px;}
        .addOrder .el-input__inner {width:300px;}
        .addOrder .el-form-item__content i.yuan {position: absolute;left:310px;}
        .drug-input .el-input .el-input__inner{width:250px;}
        .score .el-input__inner{width:70px;}
        .backup .el-input__inner{width:100px;}
        .score.el-input{width:80px;float: left;}
        .backup.el-input{width:100px;float: left;}
        .selectSate .el-input__inner {border:0;}
        .selectValue .el-input__inner {border:0;}
        .timeSetting .el-dialog__body {position: relative;top:-20px;padding-bottom: 0;}
</style>



// WEBPACK FOOTER //
// src/App.vue